import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["loading", "icon"];
import React from 'react';
import PropTypes from 'prop-types';

// Components
import IconAsBtn from '../../atoms/iconAsBtn';
import IconWithProgress from './IconWithProgress';
var IconButtonWithProgress = function IconButtonWithProgress(props) {
  var loading = props.loading,
    icon = props.icon,
    rest = _objectWithoutProperties(props, _excluded);
  if (loading) {
    return /*#__PURE__*/React.createElement(IconWithProgress, props);
  }
  return /*#__PURE__*/React.createElement(IconAsBtn, rest, " ", icon, " ");
};
IconButtonWithProgress.propTypes = {
  loading: PropTypes.bool
};
IconButtonWithProgress.defaultProps = {
  loading: false
};
export default IconButtonWithProgress;